import "./globals.css";
import "./styleguide.css";
import "./overall.css";
import React, {
  lazy,
  createContext,
  Suspense,
  useReducer,
  useState,
  useEffect,
  useCallback,
} from "react";
import { Switch, Router, Route } from "react-router-dom";
import Loading from "./components/Loading/loading.component";
import NotFound from "./Pages/NotFound/not-found.component";
import { initialState, rootReducer } from "./state/root.reducer";
import { createBrowserHistory } from "history";
import SEO from "./components/SEO/seo.component";
import { EventProvider } from "./contexts/EventContext";
import { CountryContextProvider } from "./contexts/CountryContext";

import Legal from "./Pages/Legal";

const Lp = lazy(() => import("./Pages/Lp"));

export const AppContext = createContext({});

export const history = createBrowserHistory();

const PagesWithFixedMenu = ["login", "userportal", "conditions", "politiques"];

function App() {
  const [state, dispatch] = useReducer(rootReducer, initialState);
  const [fixedMenu, setFixedMenu] = useState(false);
  const [y, setY] = useState(window.scrollY);

  const shouldPageMenuBeFixed = (path) => {
    const ix = PagesWithFixedMenu.findIndex((p) => path.indexOf(p) >= 0);
    return ix >= 0;
  };
  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      const { pathname: path } = window.location;
      // console.log(window.location);
      if (shouldPageMenuBeFixed(path)) return;

      if (y > window.scrollY) {
        if (window.scrollY === 0) {
          setFixedMenu(false);
        }
        // console.log("up");
      } else if (y < window.scrollY) {
        // console.log("down");
        if (window.scrollY > 1 && !fixedMenu) setFixedMenu(true);
      }
      setY(window.scrollY);
    },
    // eslint-disable-next-line
    [y]
  );
  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    const { pathname: path } = window.location;
    if (shouldPageMenuBeFixed(path)) {
      setFixedMenu(true);
      return;
    }
    setFixedMenu(false);
    // eslint-disable-next-line
  }, [window.location.pathname]);

  useEffect(() => {
    dispatch({
      type: "REFRESH_LOGIN",
    });
  }, []);



  return (
    <AppContext.Provider value={[state, dispatch]}>
      <Router history={history}>
        <Suspense
          fallback={
            <div className="loading-screen-suspense">
              <Loading />
            </div>
          }
        >
          <SEO />

          <Switch>
          <Route  exact={true} path="/legal">
              <Legal />
            </Route>
            <Route exact={true} path="/:id">
			<EventProvider>
      <CountryContextProvider>
        <Lp />
      </CountryContextProvider>
    </EventProvider>
            </Route>
            <Route exact={true} path="/index/:id">
			<EventProvider>
      <CountryContextProvider>
        <Lp />
      </CountryContextProvider>
    </EventProvider>
            </Route>
            
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </AppContext.Provider>
  );
}

export default App;
